<template>
  <modal-layout>
    <popup-reservation @dispose="onDispose" />
  </modal-layout>
</template>

<script>
import ModalLayout from '@/components/global/ModalLayout.vue';
import modalMixin from '@/components/global/modal-mixin';
import PopupReservation from '@/components/modal-popups/PopupReservation.vue';

export default {
  name: 'ModalReservation',
  components: {
    ModalLayout,
    PopupReservation,
  },
  mixins: [modalMixin],
  data() {
    return {
      temp: false,
    };
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modal-popups/ModalReservation.vue